import { render, staticRenderFns } from "./guardianWealth.vue?vue&type=template&id=041e5ee3"
import script from "./guardianWealth.vue?vue&type=script&lang=js"
export * from "./guardianWealth.vue?vue&type=script&lang=js"
import style0 from "./guardianWealth.vue?vue&type=style&index=0&id=041e5ee3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports